import React, {Component} from 'react';
import classes from './IP7Index.css';
import NumberFormat from 'react-number-format';
import {connect} from 'react-redux';
import * as actionTypes from '../../store/actions';
import ToolTip from '../ToolTip/ToolTip';

export class IP7Index extends Component {

    updateData = (key, value) => {


        let data = {
            yr: this.props.indexYR,
            sandp: this.props.indexSANDP,
            sandrcntl: this.props.indexSANDRCTRL,
            retiree: this.props.indexRETIREE,
            barclay: this.props.indexBarclay,
            interestRate: this.props.indexINTEREST,
            indexEAFE: this.props.indexEAFE,
        };

        data[key] = value;
        this.props.updateIP7Index(data);
    };

    render() {

        console.log(this.props.indexProtector);

        let totalClass = [classes.IP7Assets];
        if (this.props.total !== 100.0) {
            totalClass.push(classes.totalWrong);
        }

        let notForWellsFargoContent;
        if(this.props.companyName !== "WELLS_FARGO") {
            notForWellsFargoContent = (
                <React.Fragment>
                    {this.props.indexProtector != 5 && 
                    <React.Fragment>
                    <div className={classes.IP7Assets}>
                        <label>
                            S&P 500 Risk Control point-to-point with participation rate
                            <ToolTip
                                message="The S&P 500 Risk Control 10% Index tracks the investment results of an index composed of large-cap equities of the 500 leading companies but exposure is dynamically rebalanced based on observed S&P 500 historic volatility to maintain a 10% volatility targets. "
                            />
                        </label>

                        <NumberFormat
                            value={this.props.indexSANDRCTRL}
                            onValueChange={(values) => this.updateData("sandrcntl", values.value)}
                            onClick={() => this.updateData("sandrcntl", "")}
                            onBlur={() => this.updateData("sandrcntl", "BLUR")}
                            displayType={'input'}
                            suffix={'%'}
                        />
                    </div>
                    <div className={classes.IP7Assets}>
                        <label>
                            S&P U.S. Retiree Spending point-to-point with participation rate
                            <ToolTip
                                message="The S&P U.S. Retiree Spending Index tracks the investment results of an index composed of equities in economic sectors that are affected by retiree spending, such as healthcare, entertainment, and leisure. "
                            />
                        </label>
                        <NumberFormat
                            value={this.props.indexRETIREE}
                            onValueChange={(values) => this.updateData("retiree", values.value)}
                            onClick={() => this.updateData("retiree", "")}
                            onBlur={() => this.updateData("retiree", "BLUR")}
                            displayType={'input'}
                            suffix={'%'}
                        />
                    </div>
                    <div className={classes.IP7Assets}>
                        <label>
                            iShares U.S. Real Estate point-to-point with cap
                            <ToolTip
                                message="The iShares U.S. Real Estate ETF tracks the investment results of an index composed of U.S. equities in the real estate sector. "
                            />
                        </label>
                        <NumberFormat
                            value={this.props.indexYR}
                            onValueChange={(values) => this.updateData("yr", values.value)}
                            onClick={() => this.updateData("yr", "")}
                            onBlur={() => this.updateData("yr", "BLUR")}
                            displayType={'input'}
                            suffix={'%'}
                        />
                    </div>
                    </React.Fragment>}
                    
                </React.Fragment>
            );
        }

        return (
            <div className={classes.IP7Index}>
                <div className={classes.title}>Available Strategies</div>
                <div className={classes.IP7Allocations}>
                    {notForWellsFargoContent}
                    <div className={classes.IP7Assets}>
                        <label>
                            S&P 500® point-to-point with cap
                            <ToolTip
                                message="The S&P 500® Index tracks the investment results of an index composed of large-cap equities of the 500 leading companies that captures approximately 80% coverage of available market capitalization."
                            />
                        </label>
                        <NumberFormat
                            value={this.props.indexSANDP}
                            onValueChange={(values) => this.updateData("sandp", values.value)}
                            onClick={() => this.updateData("sandp", "")}
                            onBlur={() => this.updateData("sandp", "BLUR")}
                            displayType={'input'}
                            suffix={'%'}
                        />
                    </div>
                    <div className={classes.IP7Assets}>
                        <label>
                            iShares MSCI EAFE point-to-point with cap
                            <ToolTip
                                message="The iShares MSCI EAFE ETF tracks the investment results of an index composed of developed market equities, including those in Europe, Australia, Asia and the Far East."
                            />
                        </label>
                        <NumberFormat
                            value={this.props.indexEAFE}
                            onValueChange={(values) => this.updateData("indexEAFE", values.value)}
                            onClick={() => this.updateData("indexEAFE", "")}
                            onBlur={() => this.updateData("indexEAFE", "BLUR")}
                            displayType={'input'}
                            suffix={'%'}
                        />
                    </div>
                    {this.props.indexProtector != 4 && <div className={classes.IP7Assets}>
                        <label>
                            First Trust Barclays Edge Index 1-year point-to-point with cap
                            <ToolTip
                                message="The First Trust Barclays Edge Index  provides equity and fixed income exposure through a blend of the Capital Strength Index and Value Line Dividend Index and Barclays' US 2-year Treasury Futures, 5-year Treasury Futures and 10-year Note Futures Indexes while aiming to control risk by maintaining a volatility target at or below 7%."
                            />
                        </label>
                        <NumberFormat
                            value={this.props.indexBarclay}
                            onValueChange={(values) => this.updateData("barclay", values.value)}
                            onClick={() => this.updateData("barclay", "")}
                            onBlur={() => this.updateData("barclay", "BLUR")}
                            displayType={'input'}
                            suffix={'%'}
                        />
                    </div>}
                    <div className={totalClass.join(" ")}>
                        <label>Total</label>
                        <NumberFormat
                            value={this.props.total}
                            displayType={'text'}
                            suffix={'%'}
                        />
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        indexYR: state.planInfo.IP7.indexAllocation.yr,
        indexSANDP: state.planInfo.IP7.indexAllocation.sandp,
        indexSANDRCTRL: state.planInfo.IP7.indexAllocation.sandrcntl,
        indexRETIREE: state.planInfo.IP7.indexAllocation.retiree,
        indexINTEREST: state.planInfo.IP7.indexAllocation.interestRate,
        indexEAFE: state.planInfo.IP7.indexAllocation.indexEAFE,
        indexBarclay: state.planInfo.IP7.indexAllocation.barclay,
        total: state.planInfo.IP7.indexAllocation.total,
        companyName: state.globalState.companyName,
        indexProtector: state.globalState.indexProtector
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateIP7Index: (data) => dispatch({type: actionTypes.UPDATE_INDEX_ALLOCATIONS, data: data})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(IP7Index);



// WEBPACK FOOTER //
// ./src/containers/IP7Index/IP7Index.js